import {
  doc,
  collection,
  setDoc,
  getDocs,
  getFirestore,
  addDoc,
  getDoc,
  updateDoc,
  query,
  orderBy,
  onSnapshot,
} from "firebase/firestore";

import { getDocRef, getCollectionRef } from "../utils";

export async function initUserDoc(data) {
  const userRef = getDocRef("users/{{uid}}");

  await setDoc(userRef, data);
}

export async function getUserInfo() {
  const userRef = getDocRef("users/{{uid}}");

  const docSnap = await getDoc(userRef);

  if (docSnap.exists()) {
    return docSnap.data();
  } else {
    return null;
  }
}

export async function updateUserInfo(data) {
  const userRef = getDocRef("users/{{uid}}");

  await updateDoc(userRef, { ...data });
}

export async function addAttachedFile(data) {
  const attachementsRef = getCollectionRef("users/{{uid}}/attachments");

  const res = {
    ...data,
    timestamp: Date.now(),
  };

  await addDoc(attachementsRef, res);
}

export async function getAttachedFiles() {
  let attachementsRef = getCollectionRef("users/{{uid}}/attachments");
  attachementsRef = query(attachementsRef, orderBy("timestamp", "desc"));
  let res = [];

  const attachements = await getDocs(attachementsRef);

  attachements.forEach((at) => {
    if (at.data()) {
      res.push({ ...at.data(), id: at.id });
    }
  });

  return res;
}

export async function getUserDocRef() {
  const userRef = getDocRef("users/{{uid}}");
  return userRef;
}
